import getSubscriptionCtrl from 'controllers/payment/getSubscription'

export const GET_SUBSCRIPTION = 'GET_SUBSCRIPTION'
export const GET_SUBSCRIPTION_OK = 'GET_SUBSCRIPTION_OK'
export const GET_SUBSCRIPTION_FAILED = 'GET_SUBSCRIPTION_FAILED'

export function getSubscription(schoolId) {
  return function (dispatch) {
    dispatch({
      type: GET_SUBSCRIPTION,
    });

    getSubscriptionCtrl(schoolId).then(function(results) {
      dispatch({
        type: GET_SUBSCRIPTION_OK,
        result: results.data,
      });
    }).catch(function (error) {

      dispatch({
        type: GET_SUBSCRIPTION_FAILED,
        error,
      });
    });
  }
}

const initState = {
  result: {},
  fetching: false
}

export default function (state = initState, action) {
  switch (action.type) {
    case GET_SUBSCRIPTION: {
      return { ...state, fetching: true }
    }
    case GET_SUBSCRIPTION_OK: {
      let { result } = action
      if (state.error) {
        delete state.error
      }
      return { ...state, result, fetching: false }
    }
    case GET_SUBSCRIPTION_FAILED: {
      return { ...state, error: action.error, fetching: false }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Main/ducks/subscription.js